import { Stack, Typography } from '@mui/material';
import {
  MISSING_VEHICLE_VIN_MODAL_DESCRIPTION,
  MISSING_VEHICLE_VIN_MODAL_TITLE,
} from 'common/constants';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import { TertiaryButton } from 'components/lib/TertiaryButton';
import { Modal } from 'components/Modal';
import type { FC } from 'react';
import type { MissingVehicleVinModalProps } from './MissingVehicleVinModal.types';

const MissingVehicleVinModal: FC<MissingVehicleVinModalProps> = ({ open, onAccept, onCancel }) => (
  <Modal
    open={open}
    title={MISSING_VEHICLE_VIN_MODAL_TITLE}
    onClose={onCancel}
    onCloseIconClick={onCancel}
    modalHeaderDisplayItemsReversed
    modalContent={
      <Stack>
        <Typography variant="body1">{MISSING_VEHICLE_VIN_MODAL_DESCRIPTION}</Typography>
      </Stack>
    }
    modalFooter={
      <Stack gap={2} flex={1}>
        <PrimaryButton text="OK" onClick={onAccept} />
        <TertiaryButton text="Cancel" underline onClick={onCancel} />
      </Stack>
    }
  />
);

export default MissingVehicleVinModal;
